import { createI18n } from 'vue-i18n'

import db from '../db'
import { formatCurrency as formatCurrencyWithLocale } from './currencyFormat'

export const SUPPORT_LOCALES = [
  {
    name: '简体中文',
    value: 'zh',
  },
  {
    name: 'English',
    value: 'en',
  },
] as const

export type Locale = (typeof SUPPORT_LOCALES)[number]['value']

const i18n = createI18n({
  locale: db.locale,
  fallbackLocale: 'zh',
  lobalInjection: true,
})

export async function loadLocaleMessages(locale: Locale) {
  const messages = await import(`./locales/${locale}.json`)
  i18n.global.setLocaleMessage(locale, messages.default)
}

export const t = i18n.global.t

// 获取当前语言环境的便捷函数
export const getCurrentLocale = (): Locale => i18n.global.locale as Locale

/**
 * 货币格式化函数，支持国际化
 * 自动使用当前语言环境进行格式化
 */
export function formatCurrency(amount: number): string {
  const locale = getCurrentLocale()
  return formatCurrencyWithLocale(amount, locale)
}

export default i18n
